import cx from "classnames";
import type { BrushColor, BrushColors } from "../../tools/BrushTool";
import type { TextColor, TextColors } from "../../tools/TextTool";

type ToolbarColorsProps = {
  colors: BrushColors | TextColors;
  currentColor: BrushColor | TextColor | null;
  onClick: (color: BrushColor | TextColor) => void;
};

const ToolbarColors = ({
  colors,
  currentColor,
  onClick,
}: ToolbarColorsProps) => (
  <div className="flex h-full items-center gap-x-5">
    {colors.map((color) => {
      const isActive = currentColor === color;

      return (
        <button
          type="button"
          key={color}
          className={cx(
            "h-6 w-6 rounded-full border-2 border-solid border-gray-300 outline outline-[3px]",
            isActive
              ? "outline-white"
              : "transform cursor-pointer border-gray-300 outline-transparent transition-all duration-200 hover:scale-110"
          )}
          style={{ backgroundColor: color }}
          onClick={() => onClick(color)}
        />
      );
    })}
  </div>
);

export default ToolbarColors;
